import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Power } from "lucide-react";
import { API } from "../App";
import { Switch } from "./ui/switch";

// Founder-only: turn Hygiena on or off for every account.
export const HygienaSwitchCard = ({ enabled }) => {
  const [busy, setBusy] = useState(false);
  const flip = async (next) => {
    setBusy(true);
    try {
      await axios.put(`${API}/founder/hygiena-switch`, { enabled: next });
      window.dispatchEvent(new Event("hygiena-switch"));
      toast.success(next ? "Hygiena is on" : "Hygiena is off for everyone");
    } catch (e) { toast.error(e.response?.data?.detail || "Could not change Hygiena"); }
    finally { setBusy(false); }
  };
  return (
    <div className="bg-white border border-[#E5DFEC] rounded-2xl p-5 mb-6 flex items-center gap-3" data-testid="hygiena-switch-card">
      <Power className="w-4 h-4 text-[#6B4E8A]" />
      <div className="flex-1">
        <p className="font-medium text-[#6B4E8A]">Hygiena availability</p>
        <p className="text-xs text-[#64748B]" data-testid="hygiena-switch-state">{enabled ? "On — admins can use Hygiena." : "Off — unavailable to everyone until you turn it on."}</p>
      </div>
      <Switch checked={!!enabled} disabled={busy} onCheckedChange={flip} className="data-[state=checked]:bg-[#6B4E8A] data-[state=unchecked]:bg-[#CBD5E1]" data-testid="hygiena-switch-toggle" />
    </div>
  );
};
